export default __webpack_public_path__ + "static/media/hihh-round-logo.9d3f5b45.svg";